


function formatPhoneNumber(phoneNumber) {
    // Remove non-numeric characters
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');
    // Format to (XXX)-XXX-XXXX
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return `(${match[1]})-${match[2]}-${match[3]}`;
    }
    return phoneNumber;
}

function formatDollarAmount(amount) {
    // Format to American dollar format
    return `$${amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
}

function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
}

export function transformData(data) {
    const keyMapping = {
        entity_title: "Contact Name",
        property_address: "Property Address",
        property_state: "Property State",
        ab_purchase_price: "A→B Purchase Price",
        bc_purchase_price: "B→C Purchase Price",
        closing_date: "Closing Date",
        is_attorney_aware: "Attorney Aware",
        firm_name: "Firm Name",
        escrow_name: "Escrow Name",
        attorney_email: "Attorney Email",
        attorney_phone: "Attorney Phone",
        same_transactions_attorney: "Same Attorney for Both",
        ab_application_file_url: "A→B Application File",
        bc_application_file_url: "B→C Application File",
        referral_code: "Referral Code",
        channel: "How They Found Us",
        submissionDate: "Date Submitted",
        isDuplicate: "Duplicate",
        duplicateNote: "Duplicate Note"
    };

    // Fields to skip
    const skipFields = ['id', 'leadId'];

    const channelMapping = {
        "0": "Google",
        "1": "Bigger Pockets",
        "2": "Facebook",
        "3": "Carrot",
        "4": "Referral",
        "5": "Other"
    };

    const transformedData = {};

    for (const oldKey in data) {
        if (data.hasOwnProperty(oldKey)) {
            // Skip unwanted fields
            if (skipFields.includes(oldKey)) continue;

            const newKey = keyMapping[oldKey];
            // Skip if no mapping exists
            if (!newKey) continue;

            let value = data[oldKey];

            // Skip null/undefined values
            if (value === null || value === undefined || value === '') continue;

            // Transform booleans to "Yes" or "No"
            if (typeof value === 'boolean') {
                value = value ? "Yes" : "No";
            }

            // Map channel values
            if (oldKey === "channel") {
                value = channelMapping[value] || value;
            }

            // Format phone numbers
            if (oldKey === "attorney_phone") {
                value = formatPhoneNumber(value);
            }

            // Format dollar amounts
            if (oldKey === "ab_purchase_price" || oldKey === "bc_purchase_price") {
                value = formatDollarAmount(value);
            }

            // Format dates
            if (oldKey === "closing_date" || oldKey === "submissionDate") {
                value = formatDate(value);
            }

            transformedData[newKey] = value;
        }
    }

    return transformedData;
}

